import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { LogIn, ShieldAlert } from "lucide-react";

export const AdminLoginForm = () => {
    const { refresh } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/admin-auth/login", { email, password });
            await refresh();
        } catch (err) {
            const detail = err.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Credenziali non valide");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen pt-32 pb-24 flex items-center justify-center px-6">
            <form onSubmit={submit} className="max-w-sm w-full vd-card p-8">
                <div className="text-center mb-8">
                    <ShieldAlert size={32} className="text-gold mx-auto mb-4" />
                    <span className="label-eyebrow">Accesso riservato</span>
                    <h1 className="font-serif text-3xl text-ink-50 mt-3">Super-Admin</h1>
                    <p className="text-ink-400 mt-2 text-sm">Login riservato con email e password amministratore.</p>
                </div>
                <div className="space-y-4">
                    <div>
                        <label className="block text-xs text-ink-400 mb-1">Email</label>
                        <input data-testid="admin-login-email" type="email" autoComplete="username" value={email}
                            onChange={(e) => setEmail(e.target.value)} required
                            className="w-full bg-transparent border border-white/15 px-4 py-3 text-ink-50 focus:border-gold outline-none text-sm" />
                    </div>
                    <div>
                        <label className="block text-xs text-ink-400 mb-1">Password</label>
                        <input data-testid="admin-login-password" type="password" autoComplete="current-password" value={password}
                            onChange={(e) => setPassword(e.target.value)} required
                            className="w-full bg-transparent border border-white/15 px-4 py-3 text-ink-50 focus:border-gold outline-none text-sm" />
                    </div>
                    {error && <p data-testid="admin-login-error" className="text-red-400 text-xs">{error}</p>}
                    <button data-testid="admin-login-submit" type="submit" disabled={loading}
                        className="cta-gold w-full py-3.5 text-sm flex items-center justify-center gap-2 disabled:opacity-60">
                        <LogIn size={15} /> {loading ? "Accesso in corso..." : "Accedi"}
                    </button>
                </div>
            </form>
        </div>
    );
};
